/**
 * 格式化时间字符串，在 AM/PM 前添加空格
 * @param time - 时间字符串（例如："10:10AM"）
 * @returns 格式化后的时间字符串（例如："10:10 AM"）
 * @example
 * formatTime("10:10AM") // 返回 "10:10 AM"
 */
export function formatTime(time: string): string {
  // 在有字母的位置前加一个空格
  return time.replace(/([APM]{2})$/, ' $1');
}

/**
 * 将时间字符串解析为从午夜开始的分钟数
 * @param timeStr - 时间字符串（例如："10:10AM" 或 "3:45PM"）
 * @returns 从午夜开始的分钟数，如果解析失败返回 undefined
 * @example
 * parseTimeToMinutes("10:10AM") // 返回 610 (10*60 + 10)
 * parseTimeToMinutes("3:45PM")  // 返回 945 (15*60 + 45)
 */
export function parseTimeToMinutes(timeStr: string): number|undefined {
  // 匹配格式如 "10:10AM" 或 "3:45PM"
  const match = timeStr.match(/(\d+):(\d+)(AM|PM)/);
  if (!match) return undefined;
  
  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const isPM = match[3] === 'PM';
  
  // 处理12小时制
  if (isPM && hours < 12) hours += 12;
  if (!isPM && hours === 12) hours = 0;
  
  return hours * 60 + minutes;
}
